import React, { useEffect, useState } from "react";
import config from "../../../config"; // same config SettingsTab.jsx uses (config.baseURL)

// Settings > Contact Us accordion item (same Bootstrap accordion pattern as the other setting sections).
// Data comes from GET {config.baseURL}/api/contact-info
// Accepts the same props as the other setting sections (userInfo, token, onSaveClick, onDataChange);
// this section is read-only so it doesn't use them.
const ContactUs = ({ userInfo, token, onSaveClick, onDataChange }) => {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${config.baseURL}/api/contact-info`);
        const json = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(json.message || `Request failed (${res.status})`);
        if (alive) setInfo(json.data);
      } catch (e) {
        if (alive) setError(e.message || "Could not load contact details.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  const linkStyle = { color: "#1a8cff", textDecoration: "none" };

  return (
    <div className="accordion-item"  style={{ marginBottom: "2rem" }}>
      <h2 className="accordion-header" id="headingContactUs">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseContactUs"
          aria-expanded="false"
          aria-controls="collapseContactUs"
        >
          Contact Us
        </button>
      </h2>
      <div
        id="collapseContactUs"
        className="accordion-collapse collapse"
        aria-labelledby="headingContactUs"
        data-bs-parent="#settingsAccordion"
      >
        <div className="accordion-body">
          {loading && <p className="m-0">Loading…</p>}
          {error && <p className="m-0 text-danger">{error}</p>}
          {info && (
            <div className="p-2">
              <h6 className="fw-bold">Phone</h6>
              {info.phones.map((p) => (
                <div key={p.id} className="mb-2">
                  <a href={`tel:${p.number}`} style={linkStyle}>{p.display}</a>
                </div>
              ))}
              <h6 className="fw-bold mt-3">Email</h6>
              {info.emails.map((e) => (
                <div key={e.id} className="mb-2">
                  <a href={`mailto:${e.address}`} style={linkStyle}>{e.address}</a>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;